module.exports = __webpack_public_path__ + "img/watchlist.b238a921.png";